<script>
import { getCurrencyName } from '@/utils/currency'

export default {
  name: 'MenuItem',
  props: {
    product: {
      type: Object,
      required: true
    }
  },
  computed: {
    currency() {
      if (!this.product.currencyCode) return ''
      return getCurrencyName(this.product.currencyCode)
    }
  }
}
</script>

<template>
  <!-- Menu item -->
  <v-list-item class="px-0">
    <!-- Product photo -->
    <v-list-item-avatar
      color="grey lighten-3"
      tile
      height="48"
      min-width="48"
      width="48"
      class="mr-3"
    >
      <v-img
        v-if="product.photo"
        :src="product.photo"
        :lazy-src="product.photo"
        eager
      />
    </v-list-item-avatar>

    <v-list-item-content>
      <!-- Product name -->
      <router-link
        :to="{ name: 'MenuItemView', params: { id: product.id } }"
        class="menu-item-title"
      >
        <v-list-item-title class="subtitle-2 font-weight-bold">
          {{ product.name }}
        </v-list-item-title>
        <v-list-item-subtitle>
          {{ currency }} {{ product.price }}
        </v-list-item-subtitle>
      </router-link>
    </v-list-item-content>

    <div clas="actions">
      <v-btn
        outlined
        icon
        class="mr-2"
        :to="{ name: 'MenuItemView', params: { id: product.id } }"
      >
        <v-icon size="16" color="secondary" v-text="'$vuetify.icons.pen'" />
      </v-btn>
      <v-btn outlined icon @click.stop="$emit('delete', product)">
        <v-icon size="16" color="secondary" v-text="'$vuetify.icons.trash'" />
      </v-btn>
    </div>
  </v-list-item>
</template>

<style scoped lang="sass">
.menu-item-title
  text-decoration: none
  color: #000

.v-avatar--tile
  border-radius: 3px

.v-btn--icon.v-btn--outlined
  border-color: #aaa
  .v-icon
    height: 1em
    width: 1em
</style>
